/*
 * @Description: 问卷调研路由
 * @Author: ywl
 * @Date: 2021-03-02 19:30:00
 * @LastEditors: ywl
 * @LastEditTime: 2021-03-31 10:35:37
 */
import { RouteConfig } from 'vue-router';
import Layout from '@/layouts/layout.vue';
import QuestionnaireLayout from '@/views/questionnaire/create/layout/index.vue';

const questionRoute: RouteConfig[] = [
  {
    path: '/questionnaire',
    meta: { title: '问卷' },
    component: Layout,
    redirect: '/questionnaire/list.html',
    children: [
      {
        path: 'list.html',
        name: 'questionnaireSurvey',
        component: () => import('@/views/questionnaire/list.vue'),
        meta: { title: '问卷调研管理', parentTab: 'questionnaire' },
      },
      {
        path: 'exam.html',
        name: 'questionnaireExam',
        component: () => import('@/views/questionnaire/list.vue'),
        meta: { title: '考试测评管理', parentTab: 'questionnaireExam' },
      },
      {
        path: 'form.html',
        name: 'questionnaireForm',
        component: () => import('@/views/questionnaire/list.vue'),
        meta: { title: '报名表单管理', parentTab: 'questionnaireForm' },
      },
      {
        path: 'solitaire.html',
        name: 'questionnaireSolitaire',
        component: () => import('@/views/questionnaire/list.vue'),
        meta: { title: '在线接龙管理', parentTab: 'questionnaireSolitaire' },
      },

      {
        path: 'online.html',
        name: 'questionnaireOnline',
        component: () => import('@/views/questionnaire/list.vue'),
        meta: { title: '在线收款管理', parentTab: 'questionnaireOnline' },
      },
      {
        path: 'appoint.html',
        name: 'questionnaireAppoint',
        component: () => import('@/views/questionnaire/list.vue'),
        meta: { title: '在线预约管理', parentTab: 'questionnaireAppoint' },
      },
      {
        path: 'delete.html',
        name: 'questionnaireDelete',
        component: () => import('@/views/questionnaire/delete.vue'),
        meta: { title: '回收站_问卷调研', parentTab: 'questionnaire' },
      },
      {
        path: 'deleteExam.html',
        name: 'questionnaireDeleteExam',
        component: () => import('@/views/questionnaire/delete.vue'),
        meta: { title: '回收站_考试测评', parentTab: 'questionnaireExam' },
      },
      {
        path: 'deleteForm.html',
        name: 'questionnaireDeleteForm',
        component: () => import('@/views/questionnaire/delete.vue'),
        meta: { title: '回收站_报名表单', parentTab: 'questionnaireForm' },
      },
      {
        path: 'deleteSolitaire.html',
        name: 'questionnaireDeleteSolitaire',
        component: () => import('@/views/questionnaire/delete.vue'),
        meta: { title: '回收站_打卡接龙', parentTab: 'questionnaireSolitaire' },
      },
      {
        path: 'deleteOnline.html',
        name: 'questionnaireDeleteOnline',
        component: () => import('@/views/questionnaire/delete.vue'),
        meta: { title: '回收站_在线收款', parentTab: 'questionnaireOnline' },
      },
      {
        path: 'deleteAppoint.html',
        name: 'questionnaireDeleteAppoint',
        component: () => import('@/views/questionnaire/delete.vue'),
        meta: { title: '回收站_在线预约', parentTab: 'questionnaireAppoint' },
      },
      {
        path: 'templateLibrarySurvey.html',
        name: 'questionnairetemplateLibrarySurvey',
        component: () => import('@/views/questionnaire/templateLibrary.vue'),
        meta: { title: '模板库_问卷调研', parentTab: 'questionnaire' },
      },
      {
        path: 'templateLibraryExam.html',
        name: 'questionnairetemplateLibraryExam',
        component: () => import('@/views/questionnaire/templateLibrary.vue'),
        meta: { title: '模板库_考试测评', parentTab: 'questionnaireExam' },
      },

      {
        path: 'templateLibraryForm.html',
        name: 'questionnairetemplateLibraryForm',
        component: () => import('@/views/questionnaire/templateLibrary.vue'),
        meta: { title: '模板库_报名表单', parentTab: 'questionnaireForm' },
      },
      {
        path: 'templateLibrarySolitaire.html',
        name: 'questionnairetemplateLibrarySolitaire',
        component: () => import('@/views/questionnaire/templateLibrary.vue'),
        meta: { title: '模板库_打卡接龙', parentTab: 'questionnaireSolitaire' },
      },
      {
        path: 'templateLibraryOnline.html',
        name: 'questionnairetemplateLibraryOnline',
        component: () => import('@/views/questionnaire/templateLibrary.vue'),
        meta: { title: '模板库_在线收款', parentTab: 'questionnaireOnline' },
      },
      {
        path: 'templateLibraryAppoint.html',
        name: 'questionnairetemplateLibraryAppoint',
        component: () => import('@/views/questionnaire/templateLibrary.vue'),
        meta: { title: '模板库_在线预约', parentTab: 'questionnaireAppoint' },
      },
      {
        path: 'create.html',
        component: () => import('@/views/activity_common/create.vue'),
        meta: { title: '新增问卷', parentTab: 'questionnaire' },
      },
      {
        path: 'writeRecord.html',
        component: () => import('@/views/questionnaire/writeRecord/index.vue'),
        meta: { title: '问卷_我填写的', parentTab: 'questionnaire' },
      },
      // {
      //   path: '/questionnaire/writeRecord.html',
      //   component: () => import('@/views/questionnaire/writeRecord/index.vue'),
      //   meta: { title: '问卷_我填写的' },
      // },
    ],
  },
  {
    path: '/person/list.html',
    redirect: '/questionnaire/index.html',
  },
  {
    path: '/questionnaire/preview.html',
    component: () => import('@/views/questionnaire/preview/index.vue'),
    meta: { title: '问卷_预览', parentTab: 'questionnaire' },
  },
  {
    path: '/shareQuestionnaire',
    component: () => import('@/views/questionnaire/shareQuestionnaire.vue'),
    meta: {
      title: '您的好友给您共享了一份模板',
      parentTab: 'shareQuestionnaire',
    },
  },

  {
    path: '/questionnaire/copy.html',
    component: () => import('@/views/questionnaire/copyQuestion.vue'),
    meta: { title: '问卷_复制' },
  },
  {
    path: '/answerList.html',
    component: () => import('@/views/questionnaire/answerSheetDetail/answerList.vue'),
    meta: { title: '问卷_答卷详情列表' },
  },
  {
    path: '/cooperation.html',
    component: () => import('@/views/cooperation.vue'),
    meta: { title: '团队协作' },
  },
  {
    path: '/cooperationError.html',
    component: () => import('@/views/cooperationError.vue'),
    meta: { title: '团队协作' },
  },
  {
    path: '/textImport.html',
    component: () => import('@/views/questionnaire/textImport/index.vue'),
    meta: { title: '文本导入' },
  },
  {
    path: '/RedEnvelope.html',
    component: () => import('@/views/questionnaire/create/edit/setting/RedEnvelope/index.vue'),
    meta: { title: '微信红包设置' },
  },
  {
    path: '/whiteUser.html',
    component: () => import('@/views/questionnaire/create/edit/setting/whiteUser/index.vue'),
    meta: { title: '答题白名单' },
  },
  {
    path: '/unapproved.html',
    component: () => import('@/views/questionnaire/create/edit/setting/RedEnvelope/unapproved.vue'),
    meta: { title: '待审核红包' },
  },
  {
    path: '/wechatPay.html',
    component: () => import('@/views/questionnaire/create/edit/setting/RedEnvelope/wechatPay.vue'),
    meta: { title: '微信支付' },
  },
  {
    path: '/prizeLists.html',
    component: () => import('@/views/questionnaire/create/edit/setting/RedEnvelope/prizeLists.vue'),
    meta: { title: '查看中奖名单' },
  },
  {
    path: '/optionsQuota.html',
    component: () => import('@/views/questionnaire/create/edit/setting/quota/optionsQuota.vue'),
    meta: { title: '选项配额设置' },
  },
  {
    path: '/SMSReceipt.html',
    component: () => import('@/views/questionnaire/create/edit/setting/SMSReceipt/index.vue'),
    meta: { title: '答题回执' },
  },
  {
    path: '/SMSReceiptRecord.html',
    component: () => import('@/views/questionnaire/create/edit/setting/SMSReceipt/record.vue'),
    meta: { title: '答题回执发送记录' },
  },
  {
    path: '/questionnaire/answerSheetDetail.html',
    component: () => import('@/views/questionnaire/answerSheetDetail/index.vue'),
    meta: { title: '问卷_答卷详情', parentTab: 'questionnaire' },
  },
  {
    path: '/questionnaire/add.html',
    component: QuestionnaireLayout,
    name: 'questionnaireAdd',
    redirect: '/questionnaire/edit/subject.html',
    meta: { title: '问卷_新建问卷', parentTab: 'questionnaire' },
    children: [
      {
        path: '/questionnaire/release.html',
        name: 'questionnaireRelease',
        component: () => import('@/views/questionnaire/create/release/index.vue'),
        meta: { title: '问卷_问卷发布', parentTab: 'questionnaireRelease' },
      },
      {
        path: '/questionnaire/report.html',
        name: 'questionnaireReport',
        component: () => import('@/views/questionnaire/create/report/index.vue'),
        meta: { title: '问卷_问卷报表', parentTab: 'questionnaireReport' },
      },
      {
        path: '/questionnaire/setting.html',
        name: 'questionnaireSingleSetting',
        component: () => import('@/views/questionnaire/create/edit/setting/index.vue'),
        meta: { title: '问卷_设置', parentTab: 'questionnaireSingleSetting' },
      },
      {
        path: '/questionnaire/edit/subject.html',
        name: 'questionnaireSubject',
        component: () => import('@/views/questionnaire/create/edit/subject/index.vue'),
        meta: { title: '问卷_题目', parentTab: 'questionnaireEdit' },
      },
      {
        path: '/questionnaire/edit/outline.html',
        name: 'questionnaireOutline',
        component: () => import('@/views/questionnaire/create/edit/outline/index.vue'),
        meta: { title: '问卷_大纲', parentTab: 'questionnaireEdit' },
      },
      {
        path: '/questionnaire/edit/questionBank.html',
        name: 'questionnaireQuestionBank',
        component: () => import('@/views/questionnaire/create/edit/questionBank/index.vue'),
        meta: { title: '问卷_题库', parentTab: 'questionnaireEdit' },
      },
      {
        path: '/questionnaire/edit/setting.html',
        name: 'questionnaireSetting',
        component: () => import('@/views/questionnaire/create/edit/setting/index.vue'),
        meta: { title: '问卷_设置', parentTab: 'questionnaireEdit' },
      },
      {
        path: '/questionnaire/edit/logic.html',
        name: 'questionnaireLogic',
        component: () => import('@/views/questionnaire/create/edit/logic/index.vue'),
        meta: { title: '问卷_逻辑', parentTab: 'questionnaireEdit' },
      },
      {
        path: '/questionnaire/edit/style.html',
        name: 'questionnaireStyle',
        component: () => import('@/views/questionnaire/create/edit/style/index.vue'),
        meta: { title: '问卷_风格', parentTab: 'questionnaireEdit' },
      },
    ],
  },
];

export { questionRoute };
